// router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'

// 布局组件
import BlankLayout from '@/layout/BlankLayout.vue'
import MainLayout from '@/layout/MainLayout.vue'

// 页面组件（懒加载）
const Login = () => import('@/pages/Login.vue')

Vue.use(VueRouter)

export const menuRoutes = [
  {
    path: '/RiskBoard',
    name: 'RiskBoard',
    component: () => import('@/pages/RiskBoard.vue'),
    meta: { title: '实时看板', icon: 'fxkb', activeMenu: '/RiskBoard', hiddenSubMenu: true },
    children: [
      {
        path: '/MyDocument',           // 详情页路由
        name: 'MyDocument',
        component: () => import('@/pages/MyDocument.vue'),
        meta: { 
          title: '我的文件', 
          hidden: true,               // 不在菜单显示
          activeMenu: '/RiskBoard'    // 保持风险图谱菜单高亮
        }
      }
    ]
  },
  {
    path: '/AgentCenter',
    name: 'AgentCenter',
    component: () => import('@/pages/AgentCenter.vue'),
    meta: { title: '超体小元', icon: 'zkzx', activeMenu: '/AgentCenter', hiddenSubMenu: true },
    children: [
      {
        path: '/CompliExamine',
        name: 'CompliExamine',
        component: () => import('@/pages/CompliExamine.vue'),
        meta: { 
          title: '合规体检', 
          hidden: true, 
          activeMenu: '/AgentCenter'
        }
      },
    ]
  },
  {
    path: '/RiskAtlas',
    name: 'RiskAtlas',
    component: () => import('@/pages/RiskAtlas.vue'),
    meta: { title: '企业智脑', icon: 'hgtp', hiddenSubMenu: true },
    children: [
      {
        path: '/RiskAtlas/detail',           // 详情页路由
        name: 'RiskAtlasDetail',
        component: () => import('@/pages/RiskAtlasDetail.vue'),
        meta: { 
          title: '风险详情', 
          hidden: true,               // 不在菜单显示
          activeMenu: '/RiskAtlas'    // 保持风险图谱菜单高亮
        }
      }
    ]
  },
  {
    path: '/DocLibrary',
    name: 'DocLibrary',
    component: () => import('@/pages/DocumentLibrary.vue'),
    meta: { title: '文件库', icon: 'wjk', activeMenu: '/DocLibrary' }
  },
  {
    path: '/DataLoading',
    name: 'DataLoading',
    component: () => import('@/pages/DataLoading.vue'),
    meta: { title: '数据入库', icon: 'sjrk', activeMenu: '/DataLoading' }
  },
  // {
  //   path: '/ExpertsTeam',
  //   name: 'ExpertsTeam',
  //   component: () => import('@/pages/ExpertsTeam.vue'),
  //   meta: { title: '专家在线', icon: 'zjt', activeMenu: '/ExpertsTeam' }
  // },
]

const routes = [
  // ========== 无侧边栏路由 ==========
  {
    path: '/login',
    component: BlankLayout,  // 空白布局
    children: [
      {
        path: '',
        name: 'Login',
        component: Login,
        meta: { title: '登录' }
      }
    ]
  },
  // ========== 带侧边栏路由 ==========
  {
    path: '/',
    component: MainLayout,   // 主布局（带侧边栏）
    redirect: '/RiskBoard',
    children: menuRoutes     // 复用菜单路由
  },
  {
    path: '*',
    redirect: '/login'
  }
]
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
// 路由守卫：未登录跳登录页
router.beforeEach((to, from, next) => {
  // const token = localStorage.getItem('token')
  
  const token = sessionStorage.getItem('token')
  // 未登录且不是登录页
  if (!token && to.path !== '/login') {
    return next('/login')
  }
  // 已登录且是登录页
  if (token && to.path === '/login') {
    return next('/')
  }
  next()
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

export default router